import React from 'react';

export default function TotalCard({ titleTop, title, value }) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-between w-100 bg-blue text-white p-2 border rounded-2xl mt-3">
      <h6>{titleTop}</h6>
      <h4 className="text-center">{title}</h4>
      <h3 className="text-center">{value}</h3>
    </div>
  );
}
